import { useState, useEffect, useRef, useCallback } from "react";
import { getOrganizationLogoUrl } from "../services/organizationService";
import { STORAGE_KEYS } from "../constants/storage";

/**
 * Custom hook for fetching and managing organization logo
 * @param {boolean} enableCacheBusting - Whether to add cache-busting timestamp
 * @returns {Object} { logoUrl, fetchLogo, refreshLogo }
 */
export const useOrganizationLogo = (enableCacheBusting = false) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const logoUrlRef = useRef(null);

  const fetchLogo = useCallback(async () => {
    try {
      const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (!token) return;

      const endpoint = enableCacheBusting
        ? `${getOrganizationLogoUrl()}?t=${Date.now()}`
        : getOrganizationLogoUrl();

      const response = await fetch(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
        cache: enableCacheBusting ? "no-cache" : "default"
      });

      if (response.ok) {
        const blob = await response.blob();
        if (logoUrlRef.current) {
          URL.revokeObjectURL(logoUrlRef.current);
        }
        const objectUrl = URL.createObjectURL(blob);
        logoUrlRef.current = objectUrl;
        setLogoUrl(objectUrl);
      }
    } catch (err) {
      console.error("Error fetching logo:", err);
    }
  }, [enableCacheBusting]);

  useEffect(() => {
    return () => {
      if (logoUrlRef.current) {
        URL.revokeObjectURL(logoUrlRef.current);
      }
    };
  }, []);

  return { logoUrl, fetchLogo, refreshLogo: fetchLogo };
};
